import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getAlGroupsForDropdown,
    GetAllOperationEntityByGroupID,
    GetFactoryDetailsForReport,
    GetRouteDetailsForReport,
    getAllRoutesByFactoryID
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function GetFactoryDetailsForReport(data) {
    var model = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.estateID),
        routeID: parseInt(data.routeID),
        month: data.month + "-01"
    };
    const response = await CommonPost('/api/DailyRouteSummaryWithGainAndLossReport/GetFactoryDataForDailyRouteSummaryWithGainAndLossReport',
        null, model);
    return response.data;
}

async function getAllRoutesByFactoryID(factoryID) {
    var routeArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllRoutesByFactoryID', 'factoryID=' + factoryID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            routeArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return routeArray;
}

async function GetRouteDetailsForReport(data) {
    var model = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.estateID),
        routeID: parseInt(data.routeID),
        month: data.month + "-01"
    };
    const response = await CommonPost('/api/DailyRouteSummaryWithGainAndLossReport/GetRouteDataForDailyRouteSummaryWithGainAndLossReport', null, model);
    return response.data;
}

